export default __webpack_public_path__ + "static/media/bookcase.3d3d5e6f.png";